<div *ngIf="!hideSinglePill || choices?.length > 1" [ngClass]="{
  'padded-right-20 padded-left-20': ingredientChoicesType === ingredientChoicesTypeEnum.Pills,
  'overlay padded-top-20': needsOverlay && itemHasGroupChoices
}">
  <div class='btn-group ingredient-choices d-block'>
    <button *ngFor="let choice of choices;"
      class="btn btn-choice primary-bg-color shadowed fw-300 ingredient-choice font-secondary"
      [ngClass]="{'selection-bg-color selection-inverse-text-color active': selectedChoice?.name === choice.name,
                    'small-pills': smallPills,
                    'capitalize': capitalize,
                    'text-danger':  (item | orderedChoice : choice.name) && !(item | orderedChoice : choice.name).isValid() && selectedChoice?.name !== choice.name}"
      [ngModel]="selectedChoice?.name"
      (click)='onChoiceChange(choice, $event)'
      [attr.aria-pressed]="choice?.name === selectedChoice?.name"
      [value]="choice.name"
      ngDefaultControl>
      <span>{{choice.name}}</span>
    </button>
      </div>
</div>
<span class="padded-bottom-10 text-uppercase fw-700 halfs-whole-warning d-flex"
[ngClass]="{
  'pills-label-styles':ingredientChoicesType == ingredientChoicesTypeEnum.Pills,
  'overlay':isMobile&&ingredientChoicesType == ingredientChoicesTypeEnum.Pills,
  'remove-padding':!isMobile
  }"
*ngIf="isHalfAndHalf && !selectedChoice.hasHalves && (ingredientChoicesType != ingredientChoicesTypeEnum.List || ignoreIngredientGroups)">{{'component.item_editor.item_choices.pills_choices.will_be_applied_to_both_halves' | translate}}</span>
<div [ngClass]="{
  'padded-right-20 padded-left-20': ingredientChoicesType === ingredientChoicesTypeEnum.Pills,
  'padded-top-20': needsOverlay && (!itemHasGroupChoices || hideSinglePill && choices?.length === 1),
  'overlay': needsOverlay,
  'padded-top-5': !isMobile, 
  'padded-bottom-48': isMobile
}">
  <div class='fw-500 padded-bottom-10 calorie-disclaimer' *ngIf='caloriesDisclaimer'>{{caloriesDisclaimer}}</div>

  <fts-choice
    *ngIf='selectedChoice'
    [item]="item"
    [choice]='selectedChoice'
    [itemSize]='item.size'
    [isInModal]='inModal'
    [inItemEditorModal]='inItemEditorModal'
    [isDependingIngredientOrdered]="hasDependingIngredient"
    [orderedChoice]='(item | orderedChoice : selectedChoice.name)'
    [ignoreIngredientGroups]="ignoreIngredientGroups"
    [hasGraphicalBuilder]="hasGraphicalBuilder"
    [hasChoiceGroups]="hasChoiceGroups"
    (chooseHalf)='onHalfSelectionChange($event)'
    (toggleQualifier)='onQualifierSelectionChange($event)'
    (toggleIngredients)='onIngredientSelectionsChange($event)'
    (stageAction)="onStageActionChange($event)">
  </fts-choice>
</div>
